import { oauthApi } from "./api"
import { BASE_URL, CLIENT_ID } from "./config"

// The saga, refreshFlow and the 401 interceptor can all ask for a login at once;
// a second redirect aborts the first, and the page is leaving anyway
let redirecting = false

export const authorize = (appState?: { practiceId: string }) => {
  if (redirecting) return undefined
  redirecting = true
  if (appState?.practiceId) {
    const { practiceId } = appState
    return oauthApi.authorize({ practiceId } as any)
  }
  return oauthApi.authorize()
}

export const logout = () => oauthApi.logout({ clientID: CLIENT_ID, returnTo: BASE_URL })

export const authenticate = (): Promise<any> =>
  new Promise((resolve, reject) => {
    oauthApi.parseHash((err, result) => {
      if (err) {
        reject(err)
      }
      if (result) {
        resolve(result)
      }
    })
  })

export const refresh = (): Promise<any> =>
  new Promise((resolve, reject) => {
    oauthApi.checkSession({}, (err, result) => {
      if (err) {
        reject(err)
      }
      if (result) {
        resolve(result)
      }
    })
  })
